<template>
    <div>
        <div id="quote">
            <p>hi, my name is dylan and I like to build things</p>
            <h5><i>welcome to my website</i></h5>
        </div>
    </div>
</template>

<script>


export default {
    components: {
    },
    data() {
        return {
            LinkedIn: "https://www.linkedin.com/in/DylanCauwels",
            Etsy: "https://www.etsy.com",
            Github: "https://www.github.com/DylanCauwels",
            Instagram: "https://www.instagram.com/dylan.cauwels"
        }
    }
}
</script>

<style scoped>
    #title {
        position: absolute;
        top: 34vh;
        left: 7vw;
    }
    #icons {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        margin-left: 2.5vw;
    }
    #icons > div {
        margin-left: 5px;
    }
    #quote {
      background-color: #303030;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      min-height: 15vh;
    }
    #quote p {
        margin-bottom: 15px;
        font-size: 1.5rem;
        font-weight: 800;
        color: white;
        text-align: center;
    }
    #quote h5 {
        color: darkgray;
        font-size: 1.1rem;
        margin-bottom: 5px;
    }
    h1 {
        color: white;
        font-size: 72px;
        font-style: normal;
        font-weight: 300;
    }
    p {
        color: white;
        margin-bottom: 0px;
    }
</style>